import { render } from "./h1.vue?vue&type=template&id=ca74b3c2"
import script from "./h1.vue?vue&type=script&lang=js"
export * from "./h1.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/text/h1.vue'],['render',render],['__file',"h1.vue"]])

export default __exports__